<ng-container
	*ngTemplateOutlet="
    customInputTemplate ? customInputTemplate.template : baseInput;
    context: { ref: this, control: control, name: name, disabled: control.disabled, inputPlaceholder: inputPlaceholder }
  "
></ng-container>
<ng-template #baseInput>
	<input
		(keyup.enter)="input.blur()"
		[attr.class]="inputClass"
		[attr.id]="inputId"
		[attr.placeholder]="inputPlaceholder | translate"
		[formControl]="control"
		#input
		type="text"
	>
</ng-template>
<ngx-material-timepicker
	[defaultTime]="control.value"
	[format]="24"
	*ngIf="this.isMobile$ | async"
	#picker
	hostClass="mat-timepicker-container"
	timepickerClass="mat-timepicker"
></ngx-material-timepicker>
